/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

export const jobPropTypes = {
  additional_locations: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      placeId: PropTypes.string,
    }),
  ),
  additional_locations_details: PropTypes.arrayOf(
    PropTypes.shape({
      city: PropTypes.string,
      country: PropTypes.string,
      created: PropTypes.string,
      name: PropTypes.string,
      placeId: PropTypes.string,
      updated: PropTypes.string,
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
  ),
  approach: PropTypes.string.isRequired,
  benefits_custom_selected: PropTypes.arrayOf(PropTypes.string),
  benefits_pool_selected: PropTypes.arrayOf(PropTypes.string),
  company_id: PropTypes.number.isRequired,
  created: PropTypes.string,
  extra_info: PropTypes.shape({
    // additional_benefits: PropTypes.string,
    can_be_disclosed: PropTypes.bool,
    contact_person: PropTypes.string,
    contact_person_title: PropTypes.string,
    // contract_type: PropTypes.string,
    currency: PropTypes.string,
    diversity: PropTypes.bool,
    employment_type: PropTypes.string,
    employment_type_max: PropTypes.string,
    employment_type_min: PropTypes.string,
    // end_date: PropTypes.string,
    // freelance: PropTypes.bool,
    home_days: PropTypes.number,
    homeoffice: PropTypes.bool,
    introduction: PropTypes.string,
    job_video: PropTypes.string,
    // job_video_caption: PropTypes.string,
    // leadership_experience: PropTypes.bool,
    // leadership_importance: PropTypes.string,
    // management_role: PropTypes.bool,
    nice_to_have: PropTypes.string,
    // peopleToManage: PropTypes.string,
    requirements: PropTypes.string,
    // start_date: PropTypes.string,
    summary: PropTypes.string,
    superior_role: PropTypes.string,
    team_desc: PropTypes.string,
    team_language: PropTypes.string,
    team_size: PropTypes.string,
    // travel: PropTypes.bool,
    // travel_details: PropTypes.string,
    // travel_importance: PropTypes.string,
    your_role: PropTypes.string,
  }),
  // fully_remote: PropTypes.bool,
  geo_locations: PropTypes.any, // TODO: Check what is this
  has_questions: PropTypes.bool,
  id: PropTypes.number.isRequired,
  // job_industry: PropTypes.string,
  job_language: PropTypes.shape({
    created: PropTypes.string,
    language_code: PropTypes.string,
    mid: PropTypes.string,
    name: PropTypes.string,
    name_lower: PropTypes.string,
    updated: PropTypes.string,
  }),
  location: PropTypes.shape({
    name: PropTypes.string,
    placeId: PropTypes.string,
  }),
  location_city: PropTypes.string,
  location_country: PropTypes.string,
  location_lat: PropTypes.number,
  location_lng: PropTypes.number,
  opening_title: PropTypes.string,
  public_url: PropTypes.string,
  publish_to_job_board: PropTypes.bool,
  status: PropTypes.string,
  talent_languages: PropTypes.arrayOf(
    PropTypes.shape({
      display: PropTypes.shape({
        de: PropTypes.string,
        en: PropTypes.string,
        es: PropTypes.string,
        fr: PropTypes.string,
      }),
      id: PropTypes.string,
      importance: PropTypes.string,
      level: PropTypes.string,
      mid: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
};
